<template>
    <div>
        <h1>Bookmark</h1>
        <section id="my-bookmark">
            <div id="card-bookmark" v-for= "bookmark in bookmarks" :key= "bookmark.id">
                <div class="card-bookmarks" style="width: 20rem;">
                    <img src="" class="card-img-top" alt="">
                    <div class="card-body-bookmark">
                        <h5 class="card-title">{{bookmark.Product.name}}</h5>
                        <p>
                            <img class="img-bookmark" :src="bookmark.Product.imgUrl" alt="" />
                        </p>
                        <p class="card-text">{{bookmark.Product.description}}</p>
                        <p>{{ getCurrency(bookmark.Product.price) }}</p>
                        <p>Launching at {{formattedDate(bookmark.Product.createdAt)}}</p>
                        <div class="btn-bookmark">
                            <a href="#" class="btn btn-danger" @click= "deleteBookmark(bookmark.id)">Delete from bookmark</a>
                            <a href="#" class="btn btn-primary" @click= "cancel">Cancel</a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import Swal from 'sweetalert2'
export default {
    name : "BookmarkPage",
    computed : {
        bookmarks(){
            return this.$store.state.bookmarks
        }
    },
    methods : {
        deleteBookmark(id){
             

            this.$store.commit("DELETE_BOOKMARK", id)
            this.$store.dispatch('deleteBookmark')
            Swal.fire('Success Deleted')
            this.$store.dispatch('fetchBookmarks')
            this.$router.push({name : "Home"})


        },
        getCurrency : function(number){
        return new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR' }).format(number);
        },
        formattedDate : function(date){
            // return 'asuupdate'
            let options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
            let data = new Date(date)
            return data.toLocaleDateString("en-US", options);
        },
        cancel(){
            this.$router.push({name : "Home"})
        }
    },
    created(){
        this.$store.dispatch('fetchBookmarks')
    }
}
</script>

<style>
.img-bookmark{
    margin-left: 15%;
    
    width: 200px;
    height: 130px

}
.card-body-bookmark{
    width: 300px;
      height: 350px;

    /* display: flex; */
    /* justify-content: space-around; */
    background-color:#598193;
}

#card-bookmark{
    display: flex;
    flex-wrap: wrap;
}

.btn-bookmark{
    display: flex;
    justify-content: space-between;

}


</style>